// import 'react-app-polyfill/ie9';
 import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import {BrowserRouter as Router,Link,useLocation} from "react-router-dom";
import {ThreeDots} from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import {Button} from '@material-ui/core';

const apiEndpoint ='https://partner.sappa.se/api/dplay/activationlink';

const ActivateDplay = async () => {
  
  // fetch(apiEndpoint,{headers:{Authorization: '2D6AC8CF-7D30-4963-B429-09459CA23D81'}})
  //     .then(response => response.text())
  //     .then(data => window.location.href =data);
  
  window.location.href="https://auth.discoveryplus.com/se/login-affiliates?flow=sam2Picker";
  
}

function DplayActivate(props) {

    useEffect(() => {
      setTimeout(() => {
        ActivateDplay();
    }, 1500); 
        
    });

    return (
      <div className="container">
        
        <header className="App-header">
        <img src={ require('./images/Sappa_Green.png') } />
          
          <p>
            Startar aktiveringsprocess av discovery+...
          </p>
          <ThreeDots color="#000000" height={150} width={150}/>
          <img src={ require('./images/dplus.png') } />
        </header> 
  
      </div>
    );
  }

export default DplayActivate;
